import { button, paper } from '@brig/theme/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import type { SignInState } from '../auth/userManager.ts';
import { userManager } from '../auth/userManager.ts';
import { LoadingNotice } from '../components/LoadingNotice.tsx';
import * as styles from './NotFound.css.ts';

// The authorization code may be redeemed only once; StrictMode mounts effects twice in development.
let pending: Promise<string> | null = null;
function completeSignIn(): Promise<string> {
  pending ??= userManager.signinRedirectCallback().then((user) => {
    const state = user.state as SignInState | undefined;
    const target = state?.returnTo;
    return target?.startsWith('/') && !target.startsWith('//') ? target : '/harbour';
  });
  return pending;
}

export function AuthCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    completeSignIn()
      .then((target) => navigate(target, { replace: true }))
      .catch(() => {
        pending = null;
        setFailed(true);
      });
  }, [navigate]);

  if (!failed) return <LoadingNotice />;
  return (
    <main className={styles.sea}>
      <section className={`${paper} ${styles.sheet}`} role="alert">
        <h1>{t('error.authTitle')}</h1>
        <p>{t('error.authBody')}</p>
        <Link to="/" className={button({ tone: 'seal' })}>
          {t('notFound.back')}
        </Link>
      </section>
    </main>
  );
}
